import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  Stats,
  SpacerV,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { useNavigate } from "react-router";
import { TypeAnimation } from "react-type-animation";
import Lottie from "react-lottie";
import {
  OurProcess,
  Advantages,
  YouWillGet,
  Collage,
  FAQ2,
  Collage2,
  Trust,
} from "../components/Sections";
import { layout } from "../components/Layout";

export default function Branding() {
  const [news, setNews] = useState([]);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const dark = false;
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div
          className="anigrad"
          style={{ backgroundColor: dark ? "#111" : "white" }}
        >
          <div
            style={{
              height: state.auth.isMobile ? "130vh" : "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: state.auth.isMobile
                    ? state.auth.isTablet
                      ? "-300px"
                      : "-135px"
                    : "0px",
                  fontSize: state.auth.isMobile ? "25px" : "6vh",
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                  marginBottom: "25px",
                  fontWeight: "bold",
                }}
              >
                <div
                  style={{
                    fontSize: layout.heading2[state.auth.view],
                  }}
                >
                  Build a Powerful Brand with Strategic Branding
                </div>
              </div>
              <div
                style={{
                  fontSize: layout.textMedium[state.auth.view],
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                }}
              >
                We develop brand identities that leave a lasting impact. Our
                structured approach strengthens brand recognition and builds
                audience trust. We create compelling brand narratives that
                connect with the right audience and drive engagement.
              </div>
              <button
                style={{
                  marginTop: "6vh",
                  filter: dark ? "invert(0)" : "invert(1)",
                }}
                onClick={() => {
                  navigate("/get-a-quote/");
                }}
                className="squishy"
              >
                Request a free estimate
              </button>
            </div>
          </div>
          <Stats />
          {state.auth.isTablet ? (
            <SpacerV height={"300px"} background="#111" />
          ) : (
            ""
          )}
          <ContentSideBySide
            dark={dark}
            title="Branding Solutions for Stronger Market Presence"
            subtitle={
              <div>
                At Riches Media Digital, we craft branding strategies that
                position businesses for long-term success. Our team focuses on
                visual identity and brand messaging to create a cohesive
                presence. We make sure that your brand communicates effectively
                and builds strong customer relationships. Our strategic branding
                approach increases credibility and drives customer loyalty.
              </div>
            }
            image={
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/branding.json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <OurProcess
            invert={!dark}
            step1={"Brand Identity Development"}
            step1description={
              "We define core brand elements such as logo design and typography. Our team also refines color schemes to create a visually compelling identity that resonates with the target audience."
            }
            step2={"Brand Messaging and Storytelling"}
            step2description={
              "We craft brand narratives that communicate values and vision. Our team develops messaging strategies that connect emotionally and establish brand credibility."
            }
            step3={"Market Positioning and Audience Targeting"}
            step3description={
              "We research industry trends and analyze competitors to position your brand effectively. Our team refines audience segmentation and builds branding strategies that appeal to specific customer groups."
            }
            step4={"Visual Content and Brand Communication"}
            step4description={
              "We develop high-quality visual content that reflects your brand identity. Our team works on branded assets and marketing materials that strengthen brand perception."
            }
          />
          <Advantages
            invert={!dark}
            title={"Advantages of Our Branding Services"}
            title1={"Stronger Brand Recognition"}
            subtitle1={
              "We develop branding strategies that make businesses easily recognizable. This increases trust and strengthens customer loyalty."
            }
            title2={"Effective Market Positioning"}
            subtitle2={
              "We refine brand messaging to target the right audience. This approach helps businesses stand out in competitive markets."
            }
            title3={"Consistent Brand Communication"}
            subtitle3={
              "We maintain a uniform brand voice across all platforms. This strengthens identity and improves audience connection."
            }
            title4={"Higher Customer Retention"}
            subtitle4={
              "We create branding experiences that build lasting relationships. Strong brand presence increases repeat engagement and customer loyalty."
            }
          />
          <ContentSideBySideInv
            dark={dark}
            title="Our Passion is Growing Your Brand and Building Customer Trust"
            subtitle="At Riches Media Digital, we concentrate and work on creating branding strategies that strengthen customer relationships. Branding involves identity development and market positioning. It further encircles storytelling to establish a meaningful connection with audiences. Businesses need structured branding approaches that adapt to changing market trends. Our strategy increases brand recall and makes sure that businesses remain competitive. It also improves customer perception and builds long-term brand value."
            image={
              <img
                alt={"Brand Development Services"}
                style={{ width: "100%", borderRadius: "25px" }}
                src={require("../img/branding2.jpg")}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <YouWillGet
            invert={!dark}
            title1={"Strategic Brand Identity Development"}
            title2={"Targeted Market Positioning Strategies"}
            title3={"High-Impact Visual Branding Solutions"}
            title4={"Consistent Branding Across Platforms"}
            title5={"Customer-Centric Branding Approach"}
          />

          <div
            style={{
              display:
                state.auth.isMobile || state.auth.view == "TABP"
                  ? "none"
                  : "block",
            }}
          >
            <Trust invert />
          </div>
          <FAQ2
            invert={!dark}
            q1="What is branding?"
            a1="Branding defines a company’s identity and market presence. It involves logo design and messaging development to create a recognizable and trustworthy brand. Businesses use branding to attract and retain customers."
            q2="Why is branding important for my business?"
            a2="Branding builds recognition and strengthens customer trust. A well-positioned brand increases credibility and improves customer engagement. Businesses that invest in branding create strong market identities and long-term success."
            q3="How long does it take to build a strong brand?"
            a3="Brand development is a continuous process. Businesses see stronger recognition within six to twelve months based on consistency and market positioning. A well-structured branding strategy ensures long-term impact and customer loyalty."
            q4="What are the key elements of a successful brand?"
            a4="A strong brand consists of visual identity and consistent messaging. Businesses also need a unique brand voice to differentiate themselves in the market."
            q5="How do you create an effective branding strategy?"
            a5="We conduct market research and audience analysis to develop customized branding strategies. Our team refines brand positioning and messaging to create a compelling presence."
            q6="How can I measure branding success?"
            a6="Branding success is measured through customer engagement and brand recall. We track  <a href='https://richesmediadigital.com/branding/'>
                brand awareness
              </a>metrics and customer loyalty indicators to refine branding efforts."
          />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
